const tool = {
    labelWidth(customWidth, xxSmall, xSmall, small, middle, large, xLarge, xxLarge) {
        if (customWidth) {
            return customWidth;
        }
        let width = 100;
        if (xxSmall) {
            width = 100;
        } else if (xSmall) {
            width = 100;
        } else if (small) {
            width = 100;
        } else if (middle) {
            width = 100;
        } else if (large) {
            width = 100;
        } else if (xLarge) {
            width = 100;
        } else if (xxLarge) {
            width = 100;
        }
        return width;
    },
    fieldWidth(customWidth, xxSmall, xSmall, small, middle, large, xLarge, xxLarge) {
        if (customWidth) {
            return customWidth;
        }
        let width = 200;
        if (xxSmall) {
            width = 80;
        } else if (xSmall) {
            width = 100;
        } else if (small) {
            width = 120;
        } else if (middle) {
            width = 200;
        } else if (large) {
            width = 300;
        } else if (xLarge) {
            width = 400;
        } else if (xxLarge) {
            width = 500;
        }
        return width;
    },

    /**
     * 将文本转换为标准公文html格式
     * @param c
     * @returns {string}
     */
    text2Html(content, appendId, textIndent = false, surround = "div") {
        if (content == null || content == undefined) {
            return "";
        }
        let preCharacterType = null;
        let text = "";
        let items = content.split("\n");
        let index = 0;
        let cindex = 0;
        items.forEach(item => {
            if (item.length == 0) {
                return true;
            }
            if (textIndent) {
                text = text + '<' + surround + ' style="text-indent: 2em;">';
            } else {
                text = text + '<' + surround + '>';
            }
            let htmlTag = false;
            for (let i = 0; i < item.length; ++i) {
                let c = item.charAt(i);
                if (c == '<') {
                    htmlTag = true;
                }
                if (c == '>') {
                    htmlTag = false;
                    text = text + c;
                    continue;
                }
                if (htmlTag) {
                    text = text + c;
                    continue;
                }
                text = text + this.character2Html(c, appendId, cindex, index, preCharacterType);
                preCharacterType = this.checkCharacter(c);
                ++index;
                ++cindex;
            }
            text = text + "</" + surround + ">";
            //换行符也要计算
            ++cindex;
        })
        text = text.replace("<div></div>", "");
        return text;
    },

    /**
     * 字符用span包围
     * @param c
     * @param appendId
     * @param cindex
     * @param index
     * @param preCharacterType
     * @returns {*}
     */
    character2Html(c, appendId, cindex, index, preCharacterType) {
        let alphabet = "alphabet";
        let chinese = "chinese";
        let symbol = "symbol";
        let curCharacterType = this.checkCharacter(c);
        let html = "";
        let indent = null;
        if ((preCharacterType == alphabet && curCharacterType == chinese) ||
            (preCharacterType == chinese && curCharacterType == alphabet)) {
            indent = "0.3em";
        }
        if (preCharacterType == symbol && curCharacterType == symbol) {
            indent = "-0.5em";
        }
        if (indent != null) {
            if (appendId) {
                html = '<span c="' + cindex + '" id="c-' + index + '" style="margin-left:' + indent + ';">' + c + "</span>";
            } else {
                html = '<span style="margin-left:' + indent + ';">' + c + "</span>";
            }
        } else {
            if (appendId) {
                html = '<span c="' + cindex + '" id="c-' + index + '">' + c + '</span>';
            } else {
                html = c;
            }
        }
        return html;
    },


    /**
     * 判断字符类型
     * 1. 字母（包括数字和半角标点符号）
     * 2. 全角符号
     * 3. 汉字（不属于上面两种都归为汉字）
     * @param c
     * @returns {string}
     */
    checkCharacter(c) {
        let alphabet = "alphabet";
        let chinese = "chinese";
        let symbol = "symbol";
        let m1 = c.match(/[\uff00-\uffff|\u3000-\u303f]/g);
        let m2 = c.match(/[\u0021-\u007e]/g);
        return m1 ? symbol : m2 ? alphabet : chinese;
    },
    hash(content) {
        let hash = 0, i, chr;
        if (content.length === 0) return hash;
        for (i = 0; i < content.length; i++) {
            chr = content.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        return hash;
    },

    conert2PageHtml2(originHtml) {
        let virtualContent = document.getElementById('virtual-content');
        if (!virtualContent) {
            virtualContent = document.createElement("div");
            virtualContent.setAttribute("style", "visibility:hidden;position: absolute;left: 0;top: 0;width: 156mm;line-height: 10.39mm;letter-spacing: -0.4pt;word-break: break-all;font-family: 仿宋_GB2312;font-size: 16pt");
            let body = document.getElementsByTagName('body')[0];
            body.appendChild(virtualContent);
        }
        virtualContent.innerHTML = originHtml;

        let children = virtualContent.children;
        let pageHeight = document.getElementById('virtual-page').offsetHeight;
        let pages = [];
        let pageIndex = 0;
        let pageSize = 0;
        for (let i = 0; i < children.length; ++i) {
            let node = children[i];
            if (node.tagName.toLowerCase() == 'table') {
                let rows = node.children;
                let table = document.createElement("div");
                table.innerHTML = node.outerHTML;
                table = table.firstChild;
                table.innerHTML = "";

                if (rows.length == 1 && rows[0].tagName.toLowerCase() == 'tbody') {
                    rows = rows[0].children;
                }

                for (let r = 0; r < rows.length; ++r) {
                    let row = rows[r];
                    console.log("row index:" + r);
                    console.log("row size:" + row.offsetHeight);
                    console.log("page height:" + pageHeight);
                    console.log("pageSize+rowSize:" + (pageSize + row.offsetHeight));
                    if (pageSize + row.offsetHeight > pageHeight) {
                        pages[pageIndex] = pages[pageIndex] + table.outerHTML;
                        ++pageIndex;
                        pages.push("");
                        table.innerHTML = "";
                        table.appendChild(row.cloneNode(true));
                        pageSize = row.offsetHeight;
                    } else {
                        pageSize = pageSize + row.offsetHeight;
                        table.appendChild(row.cloneNode(true));
                    }
                    if (r == rows.length - 1 && table.children.length > 0) {
                        pages[pageIndex] = pages[pageIndex] + table.outerHTML;
                    }
                }
            } else {
                pageSize = pageSize + node.offsetHeight;
                if (pageSize > pageHeight) {
                    pageSize = 0;
                    ++pageIndex;
                }
                if (pageIndex >= pages.length) {
                    pages.push("");
                }
                pages[pageIndex] = pages[pageIndex] + node.outerHTML;
            }
        }
        return pages;

    },

    convert2PageHtml(doc) {
        let targetHtml = "";
        let ele = document.createElement("div");
        ele.setAttribute("style", "visibility:hidden;position: absolute;left: 0;top: 0;width: 156mm;line-height: 10.39mm;letter-spacing: -0.4pt;word-break: break-all;font-family: 仿宋_GB2312;font-size: 16pt");

        let containerEle = document.createElement("div");
        containerEle.innerHTML = doc.originHtml;
        let childrens = containerEle.children;
        let paragraphCount = 0;
        let paragraphIndex = Object.create(null);
        for (let i = 0; i < childrens.length; ++i) {
            let node = childrens[i];
            if (node.tagName.toLowerCase() == 'table') {
                targetHtml = targetHtml + node.outerHTML;
            } else {
                ++paragraphCount;
                node.id = "p" + paragraphCount;
                //node.setAttribute('style', "text-indent:2em;");
                paragraphIndex[node.id] = node.outerHTML;
                targetHtml = targetHtml + this.paragraphConvert(paragraphIndex[node.id], node.id);
            }
        }
        let virtualContent = document.getElementById('virtual-content');
        if (!virtualContent) {
            virtualContent = document.createElement("div");
            virtualContent.setAttribute("style", "visibility:hidden;position: absolute;left: 0;top: 0;width: 156mm;line-height: 10.39mm;letter-spacing: -0.4pt;word-break: break-all;font-family: 仿宋_GB2312;font-size: 16pt");
            let body = document.getElementsByTagName('body')[0];
            body.appendChild(virtualContent);
        }
        virtualContent.innerHTML = targetHtml;

        for (let i = 1; i <= paragraphCount; ++i) {
            let pElement = document.getElementById('p' + i);
            let nextElement = pElement.nextSibling;
            let index = 0;

            let preLineOffset = -1;
            let contentIndex = 0;
            let firstLine = true;

            while (true) {
                let id = 'c-p' + i + "-" + index;
                let ele = document.getElementById(id);
                if (preLineOffset == -1) {
                    if (!ele) {
                        break;
                    }
                    preLineOffset = ele.offsetTop;
                }
                let calElement = ele;
                if (!ele) {
                    //最后一行
                    calElement = document.getElementById('c-p' + i + "-" + (index - 1));
                }
                let cindex = parseInt(calElement.getAttribute("c"));
                if (!ele) {
                    ++cindex;
                }
                if (calElement.offsetTop != preLineOffset || !ele) {
                    let html = paragraphIndex[pElement.id].substring(contentIndex, cindex);
                    html = html.replace(/<p[^>]+>/g, "");
                    html = html.replace(/<\/p>/g, "");
                    let p = document.createElement("div");
                    p.innerHTML = this.text2Html(html, false, firstLine, "p");
                    preLineOffset = calElement.offsetTop;
                    contentIndex = cindex;
                    if (!nextElement) {
                        virtualContent.appendChild(p.firstChild);
                    } else {
                        virtualContent.insertBefore(p.firstChild, nextElement);
                    }
                    firstLine = false;
                }
                if (!ele) {
                    break;
                }
                ++index;
            }
        }
        return virtualContent.innerHTML;

    },
    paragraphConvert(originHtml, parentId) {

        let targetHtml = "";
        let preCharacterType = null;
        let index = 0;
        let cindex = 0;
        let characterIndex = [];
        let htmlTag = false;
        for (let i = 0; i < originHtml.length; ++i) {
            let c = originHtml.charAt(i);
            if (c == '<') {
                htmlTag = true;
                continue
            }
            if (c == '>') {
                htmlTag = false;
                continue;
            }
            if (!htmlTag) {
                characterIndex.push(i);
            }
        }
        let start = 0;
        for (let i = 0; i < characterIndex.length; ++i) {
            if (start != characterIndex[i]) {
                targetHtml = targetHtml + originHtml.substring(start, characterIndex[i]);
            }
            start = characterIndex[i] + 1;
            let c = originHtml.charAt(characterIndex[i]);
            cindex = characterIndex[i];
            index = parentId + "-" + i;
            targetHtml = targetHtml + this.character2Html(c, true, cindex, index, preCharacterType);
            preCharacterType = this.checkCharacter(c);
        }
        return targetHtml;
    },
    hasRole(role) {
        let str = localStorage.getItem("profile");
        if (!str) {
            return false;
        }
        let result=false;
        let profile = JSON.parse(str);
        let roles = profile.role.split(",");
        roles.forEach(item => {
            if (item == role) {
                result= true;
                return;
            }
        })
        return result;
    }
}

tool.install = Vue => {
    Vue.prototype.$tool = tool
}

export default tool;
